import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import TeacherProfileComp from "./Component/TeacherProfileComp"

const TeacherProfile =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <TeacherProfileComp />
        </div>
        <Footer />
        </>
    )
}

export default TeacherProfile